/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type createJiraIssueModal_viewer$ref: FragmentReference;
declare export opaque type createJiraIssueModal_viewer$fragmentType: createJiraIssueModal_viewer$ref;
export type createJiraIssueModal_viewer = {|
  +id: string,
  +project: ?{|
    +id: string,
    +jiraSubtaskType: ?string,
    +jiraCloudProject: ?{|
      +id: string
    |},
    +jiraCloudProjectSettings: ?{|
      +id: string,
      +mapJiraEpicToPhase: ?boolean,
    |},
    +jiraServerProject: ?{|
      +id: string
    |},
    +jiraCloudEpicIds: ?$ReadOnlyArray<?string>,
  |},
  +$refType: createJiraIssueModal_viewer$ref,
|};
export type createJiraIssueModal_viewer$data = createJiraIssueModal_viewer;
export type createJiraIssueModal_viewer$key = {
  +$data?: createJiraIssueModal_viewer$data,
  +$fragmentRefs: createJiraIssueModal_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "createJiraIssueModal_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jiraSubtaskType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraCloudProjectType",
          "kind": "LinkedField",
          "name": "jiraCloudProject",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraCloudProjectSettingsType",
          "kind": "LinkedField",
          "name": "jiraCloudProjectSettings",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mapJiraEpicToPhase",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraServerProjectType",
          "kind": "LinkedField",
          "name": "jiraServerProject",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jiraCloudEpicIds",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '3221a3be3c01954349b33977f1ec7562';

module.exports = node;
